import react from 'react';
import { BoostedJackpotPopup } from './boostedJackpotPopup';
import { BoostedJackpotIcon } from './boostedJackpotIcon';
import { useStore } from '../../../../hooks';
import { observer } from 'mobx-react-lite';

export const BoostedJackpot: React.FC = observer(() => {
  const { boostedJackpotStore } = useStore();
  
  const { wheelInfo, hasBoostedJackpot, showWheelWidget } = boostedJackpotStore;
  
  return (
    <>
      {wheelInfo && showWheelWidget && <BoostedJackpotIcon />}
      {hasBoostedJackpot && <BoostedJackpotPopup />}
    </>
  );
});
